var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41058 7.74408C4.73602 7.41864 5.26366 7.41864 5.58909 7.74408L9.99984 12.1548L14.4106 7.74408C14.736 7.41864 15.2637 7.41864 15.5891 7.74408C15.9145 8.06951 15.9145 8.59715 15.5891 8.92259L10.5891 13.9226C10.2637 14.248 9.73602 14.248 9.41058 13.9226L4.41058 8.92259C4.08514 8.59715 4.08514 8.06951 4.41058 7.74408Z",
    fill: "#334155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputDropdown);
export default __webpack_public_path__ + "static/media/inputDropdown.92ae5719a67addaa0241b7e0a97a05f3.svg";
export { ForwardRef as ReactComponent };